import React from "react";
import { Link } from "react-router-dom";
import "../assets/styles.css";
import imageIcon from "../assets/pad-pro-home-section-b.png";

export default function HomeSectionB() {
  return (
    <div className="bg-gray-100 py-12 sm:py-16 lg:py-20 xl:py-24">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        {/* Section Title - Enhanced responsive design */}
        <h1 className="text-xl sm:text-2xl lg:text-3xl xl:text-4xl text-black tracking-tight text-center text-gray-900 newsreader mb-8 sm:mb-12 lg:mb-16 leading-tight">
          Piedmont Adult Day Program (PADPro)
        </h1>
        
        {/* Main Content Grid - Enhanced responsive layout */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 lg:gap-16 xl:gap-20 items-center">
          
          {/* Images Section - Left Side */}
          <div 
            className="flex justify-center items-center order-2 lg:order-1" 
            data-aos="fade-right" 
            data-aos-duration="2000"
          >
            <div className="w-full max-w-sm sm:max-w-md lg:max-w-lg xl:max-w-xl">
              <img
                src={imageIcon}
                alt="Piedmont Adult Day Program activities showing classroom learning, communication devices, group activities, and hands-on skill development"
                className="w-full h-auto object-contain rounded-lg shadow-lg transition-transform duration-300 hover:scale-105"
              />
            </div>
          </div>
          
          {/* Content Section - Right Side */}
          <div 
            className="order-1 lg:order-2" 
            data-aos="fade-left" 
            data-aos-duration="2000"
          >
            <div className="max-w-2xl lg:max-w-none">
              {/* Question Heading - Enhanced responsive typography */}
              <h2 className="text-base sm:text-lg lg:text-xl font-semibold text-green-600 mb-4 sm:mb-6 leading-relaxed">
                Can we make a safer learning environment to an adult in today's time?
              </h2>
              
              {/* Content Paragraphs - Enhanced spacing and typography */}
              <div className="space-y-4 sm:space-y-6 mb-6 sm:mb-8">
                <p className="text-gray-700 text-sm sm:text-base lg:text-lg leading-relaxed">
                  Read about the latest Piedmont Adult Day Program initiatives, achievements, and developments.
                </p>
                
                <p className="text-gray-700 text-sm sm:text-base lg:text-lg leading-relaxed">
                  Overall goal of the program is to provide structure and training to assist individuals toward effective communication and empowerment through skill choice making.
                </p>
              </div>
              
              {/* Call to Action Button - Enhanced responsive design */}
              <div className="flex justify-center sm:justify-start">
                <Link 
                  to="/services"
                  className="inline-block w-full sm:w-auto"
                >
                  <button className="w-full sm:w-auto bg-red-500 hover:bg-red-600 text-white px-6 sm:px-8 lg:px-10 py-3 sm:py-4 rounded-xl font-medium text-sm sm:text-base lg:text-lg transition-all duration-200 hover:scale-105 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2">
                    LEARN MORE
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}